import { useMutation, UseMutationResult } from 'react-query';
import { MessageRequest, sendMessage } from 'api/messages';
import { AxiosError } from 'axios';

import { HttpException } from '../common/models/httpException';

export const CK_MESSAGES = 'messages';

export const useSendMessage = (): UseMutationResult<void, AxiosError<HttpException>, MessageRequest> => {
  return useMutation(sendMessage);
};
